import { HTTP as http } from '../../http'

const PREFIX = '/employee'

export default {
  
    getEmployees: (data) => {
        return http.post(PREFIX+'/getEmployees', data)
    },
  
    getEmployee: () => {
        return http.get(PREFIX+'/getEmployee')
    },

    setEmployee: (data) => {
        return http.post(PREFIX+'/setEmployee', data)
    },

}